import { ReactNode } from "react";
import AmbientWorldLayer from "./AmbientWorldLayer";
import { getRealm, resolveRealmByTitle, type RealmKey } from "./lunimarRealms";

interface LunimarSceneProps {
  realmKey?: RealmKey;
  /** Used when `realmKey` is not supplied. */
  titleHint?: string;
  className?: string;
  children: ReactNode;
}

/**
 * Lightweight Lunimar scene wrapper for simulators that don't go through
 * `LunimarModuleShell`. Adds the ambient world layer behind whatever
 * existing layout the simulator already renders — does not touch internal
 * markup, handlers, state, or progress chrome.
 */
const LunimarScene = ({
  realmKey,
  titleHint,
  className = "",
  children,
}: LunimarSceneProps) => {
  const realm = realmKey
    ? getRealm(realmKey)
    : resolveRealmByTitle(titleHint ?? "");
  return (
    <div
      className={`relative isolate min-h-screen overflow-x-hidden ${className}`}
    >
      <AmbientWorldLayer realm={realm} />
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default LunimarScene;